import { BaseRedirect } from './base-redirect';

export default BaseRedirect;
